import React from "react";

import { useCommunityValidationLock, VALIDATION_RUN_TIMEOUT_MS } from "./CommunityValidationLockContext";

import classes from "./CommunityTabValidationOverlay.module.scss";

const timeoutMinutes = VALIDATION_RUN_TIMEOUT_MS / 60000;

export default function CommunityTabValidationOverlay() {
    const { validationUiLocked } = useCommunityValidationLock();

    if (!validationUiLocked) return null;

    return (
        <div className={classes.overlay} role="status" aria-live="polite" aria-busy="true">
            <div className={classes.banner}>
                <p className={classes.title}>Validation in progress</p>
                <p className={classes.subtitle}>
                    This tab is locked until validation finishes or times out ({timeoutMinutes} minutes). You can still
                    review Configuration and Results.
                </p>
            </div>
        </div>
    );
}
